class SnsShareUrlUtil {
  twitterUrl(title: string, userAccountName: string, articleId: number): string {
    return `https://twitter.com/share?text=${title} - ${userAccountName}のプレスリリース&url=${this.releaseUrl(articleId)}`;
  }
  faceBookUrl(articleId: number): string {
    return `http://www.facebook.com/share.php?u=${this.releaseUrlForFacebook(articleId)}`;
  }
  releaseUrl(articleId: number): string {
    return `${location.origin}/pressrelease/${articleId}`;
  }
  // developmentでfacebookのシェアするときはlocalhostの場合エラーになるため`http://value-press.com`にする
  releaseUrlForFacebook(articleId: number): string {
    return process.env.NODE_ENV === "development" ? `http://value-press.com/pressrelease/${articleId}` : this.releaseUrl(articleId);
  }
}
export default SnsShareUrlUtil;
